import storeEvent from '../../utils/store-event';
import { ajax } from '../../utils/ajax-handler';
import { debounce, get } from '../../utils/object-helpers';
import { getRequestedTab, isTab } from '../../utils/tab-helpers';

const KEY = 'str-search-wrap';

export default class {
    getModule(input) {
        const baseModule = get(input, 'page.modules.SEARCH_THE_STORE_MODULE', null);
        const refs = get(baseModule, '_moduleReferences', {});
        let usedModule;
        for (const tabName in refs) {
            if (refs.hasOwnProperty(tabName) && refs[tabName] && isTab(tabName, this.currentTab)) {
                for (const altModule of refs[tabName]) {
                    usedModule = get(input, `page.modules.${altModule}`, null);
                    if (usedModule) break;
                }
            }
        }
        return usedModule || baseModule;
    }
    onCreate(input, out) {
        this.currentTab = getRequestedTab(out);
        this.updateState(input);
    }
    onInput(input) {
        this.updateState(input);
    }
    updateState(input) {
        this.input = input;
        const module = this.getModule(input);
        this.a11yTextTemplateSingle = get(module, 'searchResultsSuggestion.textSpans.0.text', '');
        this.a11yTextTemplateMultiple = get(module, 'searchResultsSuggestion.textSpans.1.text', '');
        this.state = {
            hasModule: !!module,
            keyword: '',
            suggestionListClassOpen: '',
            announceSuggestionsText: '',
            iconClass: '',
            inputClass: '',
            suggestions: [],
            activeSuggestion: null,
            placeHolderText: getPlaceholderText(module),
            autoCompleteName: get(module, 'storeSearchField.autocomplete.action.name', ''),
            searchId: input.searchId,
            accesibilityText: get(module, 'storeSearchField.accessibilityText', ''),
            isSticky: false
        };
        this.autoCompleteUrl = get(module, 'storeSearchField.autocomplete.action.URL', '');
        this.searchUrl = get(module, 'searchButtonWeb.action.URL', '');
        this.searchBoxSelector = '.str-search__input';
    }
    onMount() {
        this.subscribeTo(document.body).on('click', (e) => {
            if (e.target.classList && !e.target.classList.contains('str-search__suggestions')) {
                this.closeSuggestionsList();
            }
        });
        storeEvent.tabHasChanged.listen(detail => {
            this.currentTab = detail?.tabIndex;
            this.updateState(this.input);
        });
    }
    handleInput(e) {
        const searchTerm = e.target.value;
        this.state.keyword = searchTerm;
        const searchBoxComp = this.getEl(KEY);
        const searchBoxElem = searchBoxComp.querySelector(this.searchBoxSelector);
        if (searchTerm) {
            if (searchBoxElem) {
                searchBoxElem.setAttribute('aria-expanded', 'true');
            }
            searchTerm.trim().toLowerCase();
            debounce(this.triggerSearch(searchTerm), 500);
        } else {
            this.closeSuggestionsList();
            if (searchBoxElem) {
                searchBoxElem.setAttribute('aria-expanded', 'false');
            }
        }
    }
    triggerSearch(searchTerm) {
        const requestObj = {
            method: 'GET',
            responseType: 'json',
            withCredentials: false,
            url: `${this.autoCompleteUrl}&kwd=${encodeURIComponent(searchTerm)}`
        };
        ajax(requestObj, { successCallBack: (data) => {
            this.onResponse(data);
        } });
    }
    updateInput(keyword) {
        this.state.keyword = keyword;
    }
    handleFocus() {
        this.state.iconClass = 'str-search__icon--hide';
        this.state.inputClass = 'str-search__input--focus';
    }
    toggleActive(e) {
        this.state.activeSuggestion = null;
        this.state.suggestions.forEach((suggestion) => {
            suggestion.active = e.target.closest('li')?.getAttribute('value') === suggestion.text;
            if (suggestion.active) {
                this.state.activeSuggestion = suggestion;
            }
        });
        this.setStateDirty('suggestions');
    }
    handleInputNav(e) {
        const focusedInput = document.querySelector('.str-search__input--focus');
        const searchResults = document.querySelector('.str-search__suggestions--open');

        if (searchResults) {
            if (focusedInput && e.key === 'ArrowDown') {
                e.preventDefault();
                searchResults.firstChild.focus();
                const selectedKeyword = searchResults.firstChild.getAttribute('value');
                this.updateInput(selectedKeyword);
            }
        }
    }
    handleResultsNav(e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            const searchResults = document.querySelector('.str-search__suggestions--open');
            let selectedKeyword = this.state.keyword;
            e.preventDefault();
            e.target.blur();
            if (e.key === 'ArrowDown' && e.target.nextSibling) {
                e.target.nextSibling.focus();
                selectedKeyword = e.target.nextSibling.getAttribute('value');
            } else if (e.key === 'ArrowDown' && !e.target.nextSibling) {
                searchResults.firstChild.focus();
                selectedKeyword = searchResults.firstChild.getAttribute('value');
            } else if (e.key === 'ArrowUp' && e.target.previousSibling) {
                e.target.previousSibling.focus();
                selectedKeyword = e.target.previousSibling.getAttribute('value');
            } else if (e.key === 'ArrowUp' && !e.target.previousSibling) {
                searchResults.lastChild.focus();
                selectedKeyword = searchResults.lastChild.getAttribute('value');
            }
            this.updateInput(selectedKeyword);
        } else if (e.key === 'Enter') {
            window.location.href = `${this.searchUrl}&_nkw=${encodeURIComponent(this.state.keyword)}`;
        } else if (e.key === 'Tab') {
            this.closeSuggestionsList();
        } else {
            // any other keystrokes directly get appended to the search field
            document.getElementById(this.state.searchId).focus();
        }
    }
    handleBlur() {
        if (!this.state.keyword) {
            this.state.iconClass = '';
            this.state.inputClass = '';
        }
    }
    onSubmit(e) {
        e.preventDefault();
        if (this.state.keyword) {
            const searchTerm = this.state.keyword.trim().toLowerCase();
            window.location.href = `${this.searchUrl}&_nkw=${encodeURIComponent(searchTerm)}`;
        }
    }
    handleSuggestListSelect(e) {
        const selectedKeyword = e.target.closest('li')?.getAttribute('value');
        this.updateInput(selectedKeyword);
        window.location.href = `${this.searchUrl}&_nkw=${encodeURIComponent(selectedKeyword)}`;
    }
    onResponse(response) {
        if (response && response.res && response.res.sug) {
            const suggestions = response.res.sug;
            this.state.suggestions = [];
            suggestions.forEach((suggestion, i) => {
                this.state.suggestions.push({ id: i, text: suggestion });
            });
        }
        const suggestionsCount = this.state.suggestions.length;
        if (this.state.suggestions && suggestionsCount > 0) {
            this.setStateDirty('suggestions');
            this.state.suggestionListClassOpen = 'str-search__suggestions--open';
            this.state.announceSuggestionsText = '';
            const a11yTextTemplate = suggestionsCount > 1 ? this.a11yTextTemplateMultiple
                : this.a11yTextTemplateSingle;
            if (a11yTextTemplate) {
                // not a good practice, but UI needs this information after a delay for better user experience
                setTimeout(() => {
                    this.state.announceSuggestionsText = a11yTextTemplate.replace('{}', `${suggestionsCount}`);
                }, 500);
            }
        }
    }
    closeSuggestionsList() {
        this.state.suggestions = [];
        this.setStateDirty('suggestions');
        this.state.suggestionListClassOpen = '';
    }
}

function getPlaceholderText(input) {
    return get(input, 'storeSearchField.placeHolder.textSpans.0.text', '');
}
